<template>
  <div>
    <NetworkStatusHelperComponents1MainPage />
  </div>
</template>

<script>

import Vue from 'vue'
import Component from 'vue-class-component'

import NetworkStatusHelperComponents1MainPage from './service-for-network-status-helper-components/network-status-helper-components-1-main-page.vue'

@Component({
  components: {
    NetworkStatusHelperComponents1MainPage
  }
})
class NetworkStatus1 extends Vue {
  //
}

export default NetworkStatus1


</script>

<style>

</style>